(function () {

    document.querySelector('.header--items__search').addEventListener('click', function () {
        document.querySelector('.search-overlay__input').value = "";
        document.querySelector('.search-overlay__items-wrap').innerHTML = "";
    });

    const headerMenuCheck = document.querySelector('.header__menu-check');
    headerMenuCheck.addEventListener("click", (evt) => {
        if (document.body.id == 'lots-of-plants-shop-online-for-large-healthy-plants') {
            document.querySelector('.header--main').classList.toggle('header--main-index');
        }
        document.querySelector('.nav-overlay__wrap').classList.toggle('nav-overlay__wrap--open');
        if(headerMenuCheck.checked){
            document.body.classList.add('lop-overlay__body--freeze');
        }else{
            document.body.classList.remove('lop-overlay__body--freeze');
        }
    });

})();
